import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description: string;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 rounded-[2rem] border border-gold/20 bg-black/20 p-6 sm:flex-row sm:items-end sm:justify-between",
        className,
      )}
    >
      <div className="space-y-3">
        {eyebrow && (
          <p className="text-xs uppercase tracking-[0.3em] text-gold/90">{eyebrow}</p>
        )}
        <div className="space-y-2">
          <h1 className="section-title">{title}</h1>
          <p className="max-w-2xl text-sm leading-7 text-mist sm:text-base">
            {description}
          </p>
        </div>
      </div>
      {actions}
    </div>
  );
}
